import React, { useState, useEffect } from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import master_card from "../../../../../../../../images/v2/master24x24.svg";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import useCommonStore from "../../../../../../stores/common";
import useMerchantStore from "../../../../../../stores/merchant";
import RetrievalTable from "./table";
import { getRetrievalData } from "../../../../../../../api";
import Spinner from "../../../../../../components/Loaders/Spinner";

function Retrieval() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const dateRange = useCommonStore((state) => state.dateRange);
  const [retrievalData, setRetrievalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const fetchRetrievalData = async () => {
      setLoading(true);
      try {
        const response = await getRetrievalData({
          mid: activeApp?.power_app_submission?.mid,
          start_date: dateRange?.startDate,
          end_date: dateRange?.endDate,
          page: currentPage,
        });
        if (response?.data) {
          setRetrievalData(response?.data?.data);
          setPageCount(response.data.last_page);
          setTotalItems(response.data.total);
          setItemsPerPage(response.data.per_page);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching retrieval data:", error);
        setLoading(false);
      }
    };
    fetchRetrievalData();
  }, [dateRange, currentPage]);

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Retrieval details</h5>
            </div>
            <div className={style.right}></div>
          </header>

          <div className={style.body}>
            <RetrievalTable data={retrievalData} loading={loading} />
          </div>

          {!loading && pageCount > 1 && (
            <footer className={style.footer}>
              <Pagination
                pageCount={pageCount}
                currentPage={currentPage - 1}
                onPageChange={({ selected }) => {
                  if (selected + 1 !== currentPage) {
                    setCurrentPage(selected + 1);
                  }
                }}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
              />
            </footer>
          )}
        </div>
      )}
    </>
  );
}

export default Retrieval;
